import script from "./carousel.vue?vue&type=script&setup=true&lang=js"
export * from "./carousel.vue?vue&type=script&setup=true&lang=js"

import "./carousel.vue?vue&type=style&index=0&id=3e191613&lang=stylus&scoped=true"

import exportComponent from "D:\\Repository\\Zidan\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e191613"]])

export default __exports__